import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { addDealerType, addExcludeTestDealers } from '../analyticsQuery'
import { IChatResolutionReport, IResolutionReportParams } from '../models'

/** Tamamlananlar (Faz-37, ADR-022): aktif sonuçlandırılmış olumsuz geri bildirimler; tarih kapatma zamanına uygulanır. */
export class GetResolutionReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-analytics/resolutions', requesterInfo })
  }

  public async getReport(params: IResolutionReportParams): Promise<IChatResolutionReport> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', params.fromUtc.toISOString())
    query.add('toUtc', params.toUtc.toISOString())
    if (params.status) query.add('status', params.status)
    if (params.announced !== undefined) query.add('announced', String(params.announced))
    if (params.search) query.add('search', params.search)
    query.add('page', String(params.page))
    query.add('pageSize', String(params.pageSize))
    query.add('export', String(params.export))
    addExcludeTestDealers(query, params.excludeTestDealers)
    addDealerType(query, params.dealerType)
    this.queryParams = query
    return await this.getAsync<IChatResolutionReport>()
  }
}
